import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Api } from '@api/api';
import {
  authControllerLinkVerification,
  authControllerLogin,
  authControllerRecoveryPassword,
  authControllerSetPassword,
  authControllerSetSessionOrganizzazione,
  AuthControllerSetSessionOrganizzazione$Params,
  userControllerMe,
} from '@api/functions';
import {
  CredentialsDto,
  EditPasswordDto,
  LinkVerificationDto,
  RecoveryDto,
} from '@api/models';
import { catchError, defer, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly api = inject(Api);

  attemptAuth(credentials: CredentialsDto) {
    return defer(() =>
      this.api.invoke(authControllerLogin, { body: credentials }),
    );
  }

  userMe() {
    return defer(() => this.api.invoke(userControllerMe));
  }

  recoverPassword(body: RecoveryDto) {
    return defer(() =>
      this.api.invoke(authControllerRecoveryPassword, { body }),
    ).pipe(
      catchError((err: HttpErrorResponse) => {
        return throwError(() => err);
      }),
    );
  }

  linkVerification(body: LinkVerificationDto) {
    return defer(() =>
      this.api.invoke(authControllerLinkVerification, { body }),
    ).pipe(
      catchError((err: HttpErrorResponse) => {
        return throwError(() => err);
      }),
    );
  }

  setPassword(body: EditPasswordDto) {
    return defer(() =>
      this.api.invoke(authControllerSetPassword, { body }),
    ).pipe(
      catchError((err: HttpErrorResponse) => {
        return throwError(() => err);
      }),
    );
  }

  setSession(body: AuthControllerSetSessionOrganizzazione$Params) {
    return defer(() =>
      this.api.invoke(authControllerSetSessionOrganizzazione, body),
    ).pipe(
      catchError((err: HttpErrorResponse) => {
        return throwError(() => err);
      }),
    );
  }
}
